import { MantineThemeOverride } from '@mantine/core';

export type ScrollAreaTheme = NonNullable<MantineThemeOverride['components']>['ScrollArea'];

export const ScrollArea: ScrollAreaTheme = {
  // todo: define
};
